$(function () {

    $('#btn-reset-password').click(function () {
        let agentName = $('#in-agent').val();
        if (agentName == null || agentName.trim() == '') {
            alertify.error('Please provide the name of the agent before continuing');
            return;
        }

        $('#btn-reset-password').prop('disabled', true);

        $.post('/Agent/CreatePasswordRecoveryToken', { agentName: agentName }, function (response) {
            $('#btn-reset-password').prop('disabled', false);
            alertify.alert(response.Status ? 'Reset Password' : 'Error', response.Msn, function () {
                if (response.Status) {
                    document.location.href = "/";
                }
            });

        })

    });
})

